import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import styles from './TimelineHeatmap.module.css';

import Calendar from 'react-calendar';
import './react-calender.css';
import { AiFillCalendar, AiOutlineCalendar, AiOutlineArrowLeft, AiOutlineArrowRight } from 'react-icons/ai';
import { BiSolidRightArrow } from "react-icons/bi";

import { FaChargingStation } from "react-icons/fa6";
import { loadUser } from '../../../../Actions/Auth';
import store from '../../../../store';


const TimelineHeatmap = (props) => {

  const { chargingStations, slotDuration, timeFormatAmPm, isLoading, date, setDate, bookLimitDays, currentTime, enableQuickStart, locationTimezone } = props;

  const [showCalender, setShowCalender] = useState(false);
  const calendarViewRef = useRef(null);
  const [disablePrevBtn, setDisablePrevBtn] = useState(true);

  const [disableNextBtn, setDisableNextBtn] = useState(false);

  const _15minBefore = new Date(currentTime.getTime());
  _15minBefore.setMinutes(_15minBefore.getMinutes() - slotDuration)

  const localTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  // console.log(localTimezone , locationTimezone)

  const [showChargerTime, setShowChargerTime] = useState(false);

  const currentDateTime = new Date(currentTime);
  const currentHour = currentDateTime.getHours();
  const currentMinute = currentDateTime.getMinutes();
  const showNoSlotsAvailable = (
    date.getFullYear() == currentDateTime.getFullYear() && 
    date.getMonth() == currentDateTime.getMonth() && 
    date.getDate() == currentDateTime.getDate() && 
    (currentHour > 23 || (currentHour === 23 && currentMinute >= (60 - slotDuration)))
  
  ) ? true : false;


  const tomorrow = new Date(currentDateTime);
  tomorrow.setDate(currentDateTime.getDate() + 1);
  const prevDayNoSlotsBtnDis = (
    date.getFullYear() === tomorrow.getFullYear() && 
    date.getMonth() === tomorrow.getMonth() && 
    date.getDate() === tomorrow.getDate() &&
    (currentHour > 23 || (currentHour === 23 && currentMinute >=  (60 - slotDuration)))
  );

  useEffect(()=>{
    store.dispatch(loadUser())
  }, [])

  useEffect(() => {
   let offset = getTimeZoneOffsetTwoTimezone(localTimezone,locationTimezone)
  //  console.log(offset)
  if(offset !==0) {
    setShowChargerTime(true);
  }
  else{
    setShowChargerTime(false);
  }
  }, [locationTimezone]);

  useEffect(() => {
    const today = new Date();
    const isToday = date.getFullYear() === today.getFullYear() &&
                    date.getMonth() === today.getMonth() &&
                    date.getDate() === today.getDate();
    
    setDisablePrevBtn(isToday);
  }, [date]);


  function getTimeZoneOffsetTwoTimezone(timeZone1, timeZone2, date = new Date()) {
    // Create a date object for both time zones
    const dateInTimeZone1 = new Date(date.toLocaleString('en-US', { timeZone: timeZone1 }));
    const dateInTimeZone2 = new Date(date.toLocaleString('en-US', { timeZone: timeZone2 }));
    // Get the difference in time in milliseconds
    const timeDifferenceInMilliseconds = dateInTimeZone2.getTime() - dateInTimeZone1.getTime();
    // Convert from milliseconds to hours
    // const timeDifferenceInHours = timeDifferenceInMilliseconds / (1000 * 60 * 60);
    return timeDifferenceInMilliseconds;
}

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (calendarViewRef.current && !calendarViewRef.current.contains(event.target)) {
        setShowCalender(false);
      }
    };
    document.body.addEventListener('click', handleOutsideClick);
    return () => {
      document.body.removeEventListener('click', handleOutsideClick);
    };
  }, []);

  const forceUpdate = useForceUpdate();
  useEffect(() => {
    const intervalId = setInterval(() => {
      forceUpdate();
    }, 60000);

    return () => clearInterval(intervalId);
  }, []);

  const handleSlotClick = (startTime, quickStart = false) => {
    if (props.onSlotClick && !isLoading) {
      props.onSlotClick(startTime, quickStart);
    }
  };

  const handleDateChange = (newDate) => {
    setDate(newDate);

    const today = new Date();
    const maxAllowedDate = new Date(today.getTime() + (bookLimitDays - 1) * 24 * 60 * 60 * 1000);
  
    if (newDate >= maxAllowedDate) {
      setDisableNextBtn(true);
    } else {
      setDisableNextBtn(false);
    }
  
    if (newDate.toDateString() === today.toDateString()) {
      setDisablePrevBtn(true);
    } else {
      setDisablePrevBtn(false);
    }
  };
  
  

  // Function to navigate to the previous day
  const prevDay = () => {
    const yesterday = new Date(date.getFullYear(), date.getMonth(), date.getDate() - 1);
    const today = new Date();
    if (yesterday >= today.setDate(today.getDate() - 1)) {
      handleDateChange(yesterday);
    }
  };

  // Function to navigate to the next day
  const nextDay = () => {
    handleDateChange(new Date(date.getFullYear(), date.getMonth(), date.getDate() + 1));
  };

  // Function to find available chargers for a specific time slot
  const findAvailableChargers = (startTime, endTime) => {
    return chargingStations?.filter((station) => {
      return station.bookedSlots?.every(
        (slot) =>
          startTime >= slot.end || endTime <= slot.start
      );
    });
  };

  // Function to book a charging slot
  const bookChargingSlot = (startTime, endTime) => {
    const availableChargers = findAvailableChargers(startTime, endTime);

    if (availableChargers.length > 0) {
      // You can book the first available charger, or you can implement your own logic here.
      const stationId = availableChargers[0].id;
      const station = chargingStations?.find((station) => station.id === stationId);

      // Book the slot
      station.bookedSlots.push({ start: startTime, end: endTime });
    }
  };

  function getDayAdjustment(InputTime, timeZone) {
    const startDate = new Date(
      new Date(InputTime).toLocaleString('en-US', { timeZone: timeZone })
    );

    if (startDate.toDateString() !== InputTime.toDateString()) {
      return (startDate > InputTime ? "( +1 )" : "( -1 )") ;
    }
    return "";
  }

  // Render time slots for the day in a div with custom styles
  const renderTimeSlots = () => {
    const blocks = [];
    const interval = 12;
    // const currentTime = new Date();
    for (let dv = interval; dv <= 24; dv = dv + interval) {
      const timeSlots = [];
      for (let i = dv - interval; i < dv; i++) {
        for (let j = 0; j < 60; j += slotDuration) {
          const startTime = new Date(date.getFullYear(), date.getMonth(), date.getDate(), i, j);
          const endTime = new Date(date.getFullYear(), date.getMonth(), date.getDate(), i, j + slotDuration);
  
          const availableChargers = (enableQuickStart && startTime < currentTime && startTime > _15minBefore) ? findAvailableChargers(new Date(), endTime): findAvailableChargers(startTime, endTime);
          const totalChargingStations = chargingStations.length;
          const availabilityPercentage = (totalChargingStations > 0 && ((startTime > currentTime) || (startTime > _15minBefore)))
                ? ((availableChargers.length / totalChargingStations) * 100).toFixed(2)
                : 0;
                // console.log("percent",startTime, totalChargingStations >0&&(false ||(startTime > _15minBefore)),availabilityPercentage)
          const dayAdjustment = getDayAdjustment(startTime, locationTimezone);
          timeSlots.push(
            <div
              className={`
                ${styles['time-slot-container']} 
                ${(startTime <= currentTime) ? styles['prev-time'] : ''} 
                ${(availableChargers.length > 0 && (startTime > currentTime)) ? 
                  styles['available'] : 
                  (
                    // !(availableChargers.length > 0 && (startTime > currentTime)) && (startTime > _15minBefore) 
                    (enableQuickStart && startTime > _15minBefore && availableChargers.length !== 0) 
                    ? styles['quick-booking'] 
                    : styles['booked'])
                }
              `}
                
              key={`${dv}-${i}-${j}`}
              onClick={() => (availableChargers.length > 0 && (startTime > currentTime)) ? handleSlotClick(startTime) : ((enableQuickStart && startTime > _15minBefore && availableChargers.length !== 0)  ? handleSlotClick( new Date(startTime.setMinutes(startTime.getMinutes() + slotDuration)) , true)  : undefined)}
            >
              <div className={`${styles['time-slot']}`}>
                {/* {`${startTime.getHours()}:${String(startTime.getMinutes()).padStart(2, '0')}`} */}
                {
                // !(availableChargers.length > 0 && (startTime > currentTime)) && (startTime > _15minBefore) ? 
                  (enableQuickStart && startTime < currentTime && startTime > _15minBefore && availableChargers.length !== 0) 
                  ?
                  // currentTime.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: timeFormatAmPm? true : false })
                  <div>Now</div>
                  :
                  <div>
                    <span>{startTime.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: timeFormatAmPm? true : false })}</span>
                    {((startTime > currentTime && availableChargers.length !== 0) && showChargerTime) && <div className={`${styles['charger-timezone']} ${dayAdjustment ? styles['extra-width'] : ''}`}>
                      {startTime.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: timeFormatAmPm? true : false, timeZone: locationTimezone })}{dayAdjustment}<FaChargingStation className={styles['charger-icon']} /> 
                    </div>}
                  </div>
                }
              </div>
              {isLoading 
              ? 
              <div className={styles['slot-loading']}>
                <p className={`card-text placeholder-${j%2 == 0 ? 'glow' : 'wave'}`}>
                  <span className="placeholder col-12"></span>
                </p>
              </div> 
              :
              <div
                style={{ backgroundColor: `rgba(24, 54, 94, ${availabilityPercentage}%)`, color: (availabilityPercentage < 50 ? '#18365E' : '#fff') }}
                className={`${styles['slot']} ${showChargerTime ? styles['inc-charger-time'] : ''}`}
                onClick={() => {
                  if (availableChargers.length > 0) {
                    bookChargingSlot(startTime, endTime);
                  }
                }}
              >
                {(availableChargers.length > 0 && (startTime > currentTime))
                  ? <div data={availableChargers.map((charger) => charger.title).join(', ')}> 
                      <span>{availableChargers.length} available</span>
                    </div>
                  : <div>
                      {
                        (enableQuickStart && startTime > _15minBefore && availableChargers.length !== 0)  
                          ? 
                          <div data={availableChargers.map((charger) => charger.title).join(', ')}>
                            {/* <span className={styles['arrow-right']} /> */}
                            <span>{availableChargers.length} available</span>
                          </div>
                          :'Not available'
                      }
                    </div>
                }
              </div>}
            </div>
          );
        }
      }
      const block = (
        <div key={`block-${dv}`} className={styles['blocks']}>
          {timeSlots}
        </div>
      );
      blocks.push(block);
    }
    return blocks;
  };
  
  

  return (
    <div className={styles["calendar"]}>
      <div className={styles["header"]}>
        <button disabled={disablePrevBtn || isLoading || prevDayNoSlotsBtnDis} className={styles["button"]} onClick={prevDay}><AiOutlineArrowLeft /><span>Previous</span></button>

        <div ref={calendarViewRef}>
          <button onClick={()=>{setShowCalender(!showCalender)}} className={styles['calendar-date']}>{date?.toDateString()} {showCalender ? <AiFillCalendar /> : <AiOutlineCalendar />}</button>
          {showCalender && <div className={isLoading ?  styles['calendar-view'] + ' ' + styles['loading'] :  styles['calendar-view']}>
            <div className={styles["calendar-tip"]}></div>
            <Calendar view={'month'} minDate={new Date()} maxDate={new Date(new Date().getTime() + bookLimitDays * 24 * 60 * 60 * 1000)} calendarType='iso8601' onChange={isLoading ? undefined : handleDateChange} value={date} />
          </div>}
        </div>
        <button disabled={disableNextBtn || isLoading} className={styles["button"]} onClick={nextDay}><span>Next</span> <AiOutlineArrowRight /></button>
      </div>

      {
          <div className={styles["charging-stations-container"]}>
            {showChargerTime &&
              <div className={styles['top-charger-timezone']}>
                <span className={styles['border-animation']}>
                  {locationTimezone}<FaChargingStation />
                </span>
              </div>
            }
            {renderTimeSlots()}

            {showNoSlotsAvailable ? <div className={styles['no-slots']}>
              No slots are available today!
              <button onClick={()=>{
                setDate(new Date(date.setDate(date.getDate() + 1)));
              }}>Goto Next Day</button>
            </div> : <></>}

          </div>
      }
      {showChargerTime && 
        <div className={styles['bottom-charger-timezone']}>
          <span className={styles['border-animation']}>
            {locationTimezone}<FaChargingStation />
          </span>
        </div>
      }
    </div>
  );
};

TimelineHeatmap.propTypes = {
  chargingStations: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      bookedSlots: PropTypes.arrayOf(
        PropTypes.shape({
          start: PropTypes.instanceOf(Date).isRequired,
          end: PropTypes.instanceOf(Date).isRequired,
        })
      ),
    })
  ),
  slotDuration: PropTypes.number,
  timeFormatAmPm: PropTypes.bool,
  onSlotClick: PropTypes.func,
  date:  PropTypes.instanceOf(Date).isRequired,
  setDate: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
};

const useForceUpdate = () => {
  const [, setTick] = useState(0);
  const forceUpdate = () => {
    setTick((tick) => tick + 1);
  };
  return forceUpdate;
};

export default TimelineHeatmap;
